module.exports = __webpack_public_path__ + "static/dmhas-569b4cf01919619b4ead1ec232e01761.jpg";